import React from 'react';

const Footer = () => (
  <div className="mt-32 bg-white">
    <p className="dark:text-gray-200 text-gray-700 text-center m-20 ">
      © 2022 Tous droits  reserve par Diallo Abdoulaye
    </p>
  </div>
);

export default Footer;